export default __webpack_public_path__ + "static/Carozzi-9fe657443ce688362cfd043e674856e0.png";